import React, { useState } from 'react';
import { Modal, Button, LoadingIcon } from '@prosolve/common-components-ui'
import FileUpload from '../sharedComponents/FileUpload';

const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // matches the API's multer limit

export default ({
  currentPath = '',
  uploadAssetFiles,
  onClose,
  onUploaded
}) => {
  const [files, setFiles] = useState([])
  const [isBusy, setIsBusy] = useState(false)
  const [existingFiles, setExistingFiles] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')

  const doUpload = async (overwrite) => {
    try {
      setIsBusy(true)
      setErrorMessage('')
      const result = await uploadAssetFiles(currentPath, files, overwrite)

      if (result && result.success === false && result.existingFiles) {
        setExistingFiles(result.existingFiles)
        setIsBusy(false)
        return;
      }

      onUploaded()
      onClose()
    } catch (e) {
      setIsBusy(false)
      setExistingFiles(null)
      setErrorMessage(typeof e === 'string' ? e : 'Upload failed')
    }
  }

  if (existingFiles) {
    const footer = (
      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        columnGap: '10px',
        padding: '10px'
      }}>
        <Button onClick={() => setExistingFiles(null)}>
          {'Cancel'}
        </Button>
        <Button
          onClick={() => { setExistingFiles(null); doUpload(true); }}
          style={{ background: '#fa8900', color: '#ffffff' }}
        >
          {'Replace'}
        </Button>
      </div>
    )

    return (
      <Modal title='Files Already Exist' isAutoHeight={true} closeOnOffClick={false} onClose={() => setExistingFiles(null)} footer={footer}>
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: '15px' }}>
          <div>
            {'The following file(s) already exist in this folder:'}
            <ul style={{ margin: '10px 0px', paddingLeft: '20px' }}>
              {existingFiles.map((name) => <li key={name}>{name}</li>)}
            </ul>
          </div>
          <div style={{
            padding: '10px',
            background: '#fff7e6',
            border: '1px solid #fa8900',
            borderRadius: '5px',
            color: '#565656'
          }}>
            {'Replacing them keeps the same URL but changes the content behind it. Anything linking to these URLs will show the new files.'}
          </div>
          <div>{'Do you want to replace them?'}</div>
        </div>
      </Modal>
    )
  }

  const footer = (
    <div style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={() => doUpload(false)} $colored={true} $disabled={files.length === 0 || isBusy} style={{ position: 'relative' }}>
        {isBusy ? <LoadingIcon /> : 'Upload'}
      </Button>
    </div>
  )

  return (
    <Modal title='Upload Files' isAutoHeight={true} closeOnOffClick={false} onClose={onClose} footer={footer}>
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
        <div style={{ color: '#565656', fontSize: '14px' }}>
          {'Uploading to: '}<b>{currentPath ? `Assets/${currentPath}` : 'Assets'}</b>
        </div>
        <FileUpload
          maxSize={MAX_FILE_SIZE_BYTES}
          onFilesChanged={setFiles}
        />
        {errorMessage && <div style={{ color: '#ef0c0c', fontSize: '13px' }}>{errorMessage}</div>}
      </div>
    </Modal>
  )
}
